import FullScreenSpinner from '@components/FullScreenSpinner/FullScreenSpinner';
import { appServerSideTranslations } from '@utils/pageUtils';

import { NextPage } from 'next';
import dynamic from 'next/dynamic';

const LandingPageV3 = dynamic(() => import('../features-v2/common/landing-v3/landing-page-v3'), {
  ssr: false,
  loading: () => <FullScreenSpinner />
});

const Landing: NextPage = () => <LandingPageV3 />;

export async function getServerSideProps({ locale }: { locale?: string }) {
  return { props: await appServerSideTranslations(locale, []) };
}

export default Landing;
